module.exports = __webpack_public_path__ + "static/media/php-document.f299b57d.svg";